module.exports = __webpack_public_path__ + "img/Ebola.df706217.png";